import { Card, CardBody, NotFound, createFeedbackService } from "@dgs/core";
import { isBefore } from "date-fns";
import { FC, useMemo } from "react";
import { Route, Routes } from "react-router";
import { EventFeedbackEvaluation } from "../../../../../shared/events/feedback/EventFeedbackEvaluation";
import { EventDetailResource } from "../../../shared/types";
import { EventFeedbackDetailsPage } from "./EventFeedbackDetailsPage";
import { EventFeedbackList } from "./EventFeedbackList";

interface Props {
	event: EventDetailResource;
}

export const EventFeedbackPage: FC<Props> = ({ event }) => {
	const feedbackService = useMemo(() => {
		return createFeedbackService(["events", `${event.id}`]);
	}, [event.id]);

	const hasEventEnded = isBefore(event.end, new Date());

	if (hasEventEnded) {
		return (
			<Card>
				<CardBody>
					<EventFeedbackEvaluation eventId={event.id} />
				</CardBody>
			</Card>
		);
	}

	return (
		<Routes>
			<Route
				index
				element={<EventFeedbackList service={feedbackService} canCreate={event.canCreateFeedback} eventId={event.id} />}
			/>
			<Route
				path=":feedbackId/details"
				element={<EventFeedbackDetailsPage feedbackService={feedbackService} eventId={event.id} />}
			/>
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
